<template>
  <div class="text-left">
    <v-menu
      offset-x
      :close-on-content-click="false"
      :close-on-click="closeOnClick"
      v-model="value"
      min-width="120px"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text icon class="btn-agent-drop">
          <v-icon x-small class="mr-3">fa fa-database</v-icon>
          <div class="text-agent-drop">Agent</div>
          <v-spacer></v-spacer>
        </v-btn>
      </template>

      <v-list dense class="list-menu-agent text-agent-drop">
        <v-list-item v-for="(item, index) in getAgentList" :key="index">
          <v-list-item-content
            >{{ item.agentNm }}
          </v-list-item-content>
          <div class="ml-3 mr-3">
            <!--<v-icon x-small>fa fa-edit</v-icon>-->
            <companyAgentDetailWindow
              title="Agent Info."
              :dataValue="item"
              txtComp="getValue"
              @refreshAgentList="refreshList"
            >
            </companyAgentDetailWindow>
          </div>
          <v-btn @click="deleteAgent(item)" text icon mt-2>
            <v-icon x-small>fa fa-trash-alt</v-icon>
          </v-btn>
        </v-list-item>
        <v-row dense>
          <v-col cols="12" class="footer-agent-list">
            <v-row no-gutters>
              <companyAgentDetailWindow
                title="Add Agent"
                btnTxt="Create new Agent"
                :dataValue="getDataValue"
                class="no-gutters created-align"
                @refreshAgentList="refreshList()"
              ></companyAgentDetailWindow>
            </v-row>
          </v-col>
        </v-row>
      </v-list>
    </v-menu>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="
        $t('msg.common.infoConfirm.detail', ['delete the agent'])
      "
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem(deleteItem)"
    >
    </dialogWindow>
  </div>
</template>


<script>
import companyAgentDetailWindow from "@/vue-caas/views/company/CompanyAgentDetail.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";

export default {
  components: {
    companyAgentDetailWindow,
    dialogWindow
  },
  props: {
    companyValue: {
      default: Object,
    },
  },

  data() {
    return {
      value: false,
      closeOnClick: true,
      agentList: [],
      checkDialogInfo: "",
      deleteItem: {},
      dataValue : {
        compId: "",
        agentId: "",
        agentNm: "",
        agentAddress: "",
        agentPort: "",
      },
    };
  },
  computed: {
    getAgentList() {
      return this.agentList;
    },
    getDataValue() {
      return this.dataValue;
    },
  },
  created() {
    this.searchData();
    this.dataValue.compId = this.companyValue.compId;
  },
  methods: {
    onDeleteItem(item) {
      this.$store
        .dispatch("deleteAgent", { agentId: item.agentId, compId: this.companyValue.compId})
        .then(() => {
          this.refreshList();
          this.$refs.deleteDialog.dialog = false;
        });
    },
    deleteAgent(item) {
      this.deleteItem = Object.assign({}, item);
      this.$refs.deleteDialog.dialog = true;
     
    },
    refreshList() {
      this.searchData()
      this.$emit("refreshList");
    },
    searchData() {
      this.$store
        .dispatch("getAgentList", { compId: this.companyValue.compId })
        .then(() => {
          this.agentList = this.$store.getters.agents;
          this.agentList.forEach(e => {
            e.compId = this.companyValue.compId;
          });
        });
    },
  },
};
</script>
<style>
.theme--dark .list-menu-agent {
  background: #373b46;
}
.btn-agent-drop {
  height: 28px !important;
  width: 88px !important;
}
.footer-agent-list {
  padding-top: 0px;
  padding-bottom: 14px;
}
.theme--dark .footer-agent-list >>> .v-btn__content {
  color: #0082ba !important;
  text-decoration: underline;
}
.text-agent-drop {
  font-size: 12px !important;
}
</style>